import { UNIT_FIELD_TYPE } from "./types";
export function normalizeUnitFieldValue(value) {
    if (value == null)
        return [];
    if (Array.isArray(value)) {
        return value.filter((item) => typeof item === "string" && item.length > 0);
    }
    if (typeof value === "string" && value.length > 0)
        return [value];
    return [];
}
export function resolveDisplayUnitId(value) {
    return normalizeUnitFieldValue(value)[0] ?? null;
}
export function resolveEntryUnitIds({ entry }) {
    const record = entry;
    const field = record?._metadata?.fields?.find((item) => item.type === UNIT_FIELD_TYPE);
    if (!field)
        return [];
    return normalizeUnitFieldValue(record?.[field.name]);
}
export function resolveEntryUnit({ entry, units, }) {
    if (!units?.length)
        return null;
    for (const unitId of resolveEntryUnitIds({ entry })) {
        const unit = units.find((item) => item.id === unitId);
        if (unit)
            return unit;
    }
    return null;
}
